import Immutable from 'seamless-immutable';
import { completeReducer, createReducer } from 'redux-recompose';

import { actions } from './actions';

/* ------------- Utility reducer ------------- */
const defaultState = {
  complaintFormLoading: false,
  complaintForm: null,
  automaticDebitFormLoading: false,
  automaticDebitForm: null,
  digitalBillFormLoading: false,
  digitalBillForm: null,
  appConfiguration: null,
  appConfigurationLoading: null,
  healthCheck: {},
  healthCheckLoading: false,
  officeAvailabilityDays: [],
  officeSlot: []
};

const reducerDescription = {
  primaryActions: [
    actions.HEALTH_CHECK,
    actions.GET_COMPLAINT_FORM,
    actions.GET_AUTOMATIC_DEBIT_FORM,
    actions.GET_DIGITAL_BILL_FORM,
    actions.GET_DIGITAL_BILL_FORM,
    actions.GET_CONFIG,
    actions.GET_OFFICES,
    actions.GET_OFFICE_AVAILABILITY_DAYS,
    actions.GET_OFFICE_SLOT
  ],
  override: {
    [actions.CLEAN_OFFICE_DATA]: state =>
      Immutable.merge(state, {
        commercialOffices: null,
        officeAvailabilityDays: [],
        officeSlot: []
      }),

    [actions.CLEAN_OFFICE_SLOT]: state =>
      Immutable.merge(state, {
        officeSlot: [],
        officeSlotError: null
      }),

    [actions.HEALTH_CHECK_FAILURE]: (state, action) =>
      Immutable.merge(state, {
        healthCheck: { healthy: false, message: action.payload },
        healthCheckLoading: false
      }),

    [actions.GET_OFFICES_SUCCESS]: (state, action) =>
      Immutable.merge(state, {
        [action.target]: action.payload,
        [`${action.target}Loading`]: false
      }),

    [actions.GET_OFFICES_FAILURE]: (state, action) =>
      Immutable.merge(state, {
        [`${action.target}Error`]: action.payload,
        [`${action.target}Loading`]: false
      }),

    [actions.GET_OFFICE_AVAILABILITY_DAYS]: state =>
      Immutable.merge(state, {
        officeAvailabilityDays: [],
        officeSlot: [],
        officeAvailabilityDaysLoading: true
      })
  }
};

export const reducer = createReducer(Immutable(defaultState), completeReducer(reducerDescription));
